<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="content">
  <div class="heading">Search for Customer</div>

  <div class="search-controls">
    <mat-form-field class="search-field">
      <mat-label>Search Term</mat-label>
      <input matInput class="search-term" [(ngModel)]="searchTerm" (keyup.enter)="search()" />
    </mat-form-field>
    <button mat-stroked-button class="search-button" (click)="search()" [disabled]="searchTerm.length < 3">
      Search
    </button>
  </div>

  <div class="table-holder">
    <div class="spinner-container">
      <mat-progress-spinner
        *ngIf="loadingResults"
        color="primary"
        mode="indeterminate"
        diameter="58"
      ></mat-progress-spinner>
    </div>
    <table *ngIf="!loadingResults" class="search-results">
      <thead>
        <tr>
          <th>User ID</th>
          <th>E-mail</th>
          <th>Licenses</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let r of searchResultsPage"
          (click)="onClickResult(r)"
          [ngClass]="r === selectedResult ? 'selected' : ''"
        >
          <td>{{ r.user_id }}</td>
          <td>{{ r.email }}</td>
          <td>{{ r.licenses?.join(', ') }}</td>
        </tr>
      </tbody>
    </table>
    <mat-paginator
      *ngIf="!loadingResults && searchResults.length > pageSize"
      [pageSize]="pageSize"
      [length]="searchResults.length"
      (page)="handlePageEvent($event)"
    >
    </mat-paginator>
  </div>
  <div class="button-row">
    <button mat-raised-button class="select-button" (click)="selectCustomer()" [disabled]="!selectedResult">
      Select Customer
    </button>
    <button mat-raised-button class="cancel-button" (click)="cancel()">Cancel</button>
  </div>
</div>
